export enum RegistrySetRequestTypes {
    GET_TRANSACTION_LIST = '@@RegistrySetRequest/GET_TRANSACTION_LIST',
    GET_TRANSACTION_LIST_SUCCESS = '@@RegistrySetRequest/GET_TRANSACTION_LIST_SUCCESS',
    GET_TRANSACTION_LIST_ERROR = '@@RegistrySetRequest/GET_TRANSACTION_LIST_ERROR',
    
    GET_FILTER_LIST = '@@RegistrySetRequest/GET_FILTER_LIST',
    GET_FILTER_LIST_SUCCESS = '@@RegistrySetRequest/GET_FILTER_LIST_SUCCESS',
    GET_FILTER_LIST_ERROR = '@@RegistrySetRequest/GET_FILTER_LIST_ERROR',

    GET_TRANSACTION_COUNT = '@@RegistrySetRequest/GET_TRANSACTION_COUNT',
    GET_TRANSACTION_COUNT_SUCCESS = '@@RegistrySetRequest/GET_TRANSACTION_COUNT_SUCCESS',
    GET_TRANSACTION_COUNT_ERROR = '@@RegistrySetRequest/GET_TRANSACTION_COUNT_ERROR',
}

